import { Box, Button } from '@mui/material';
import { useGame } from 'contexts/Game/Game';
import { usePage } from 'contexts/Page/Page';
import { useSounds } from 'contexts/Sounds/Sounds';
import { formatMoney } from 'helpers';
import { useMemo } from 'react';
import { MaterialSymbol } from 'react-material-symbols';
import * as setup from 'setup';

const { spyOpponentCost } = setup.cards;
const disabledRounds = ['init', 'hole', 'next', 'end'];

export default function SpyButton({ opponent, tabIndex }: SpyButtonProps) {
    const game = useGame();
    const page = usePage();
    const sounds = useSounds();

    const { highlightSpyOpponents, spyButtonLesson } = game.lessonProps;

    const disabled = useMemo(() => {
        return (
            !spyButtonLesson &&
            (game.opponentsSpied[opponent] || spyOpponentCost > game.budget || disabledRounds.includes(game.round))
        );
    }, [game.budget, game.round, game.opponentsSpied, opponent, spyButtonLesson]);

    const label = useMemo(() => {
        return `Spy $${formatMoney(spyOpponentCost)}`;
    }, []);

    function handleClick() {
        if (!game.loading && game.ready) {
            sounds.play('spy');
            game.spyOpponent(opponent);

            if (spyButtonLesson) {
                page.show(spyButtonLesson);
            }
        }
    }

    return (
        <Box left="100%" position="absolute" top="calc(50% - 18px)">
            <Button
                className={highlightSpyOpponents ? undefined : 'compact'}
                color={highlightSpyOpponents ? 'primary' : 'inherit'}
                disabled={disabled}
                startIcon={<MaterialSymbol aria-hidden icon="visibility" size={23} />}
                tabIndex={tabIndex}
                variant="text"
                onClick={handleClick}
            >
                <Box className="compact-inner">{label}</Box>
            </Button>
        </Box>
    );
}
